import { render, staticRenderFns } from "./NewProjectAction.vue?vue&type=template&id=36dfe4d5&"
import script from "./NewProjectAction.vue?vue&type=script&lang=js&"
export * from "./NewProjectAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports